<template>
  <div ref="containerRef" class="timeline-container">
    <div class="carousel-wrapper">
      <!-- Arrows -->
      <button
        class="carousel-button left"
        @click="prevSlide"
        v-if="currentIndex > 0"
        aria-label="Previous"
      >‹</button>
      <button
        class="carousel-button right"
        @click="nextSlide"
        v-if="currentIndex < hotels.length - 1"
        aria-label="Next"
      >›</button>

      <div class="carousel" :style="{ transform: `translateX(-${currentIndex * 100}%)` }">
        <div
          v-for="(hotel, index) in hotels"
          :key="index"
          class="hotel-card"
          :ref="el => setHotelCard(el, index)"
        >
          <p class="recomendacion-hospedaje" :ref="el => setRefs(el, index, 'titulo')">{{ hotel.titulo }}</p>
          <p :ref="el => setRefs(el, index, 'descripcion')">{{ hotel.descripcion }}</p>
          <img
            :src="hotel.imagen"
            :alt="hotel.nombre"
            class="hotel-image rounded-circle"
            :ref="el => setRefs(el, index, 'imagen')"
          />
          <div class="hotel-info" :ref="el => setRefs(el, index, 'info')">
            <h3>{{ hotel.nombre }}</h3>
            <strong>Address:</strong><br />
            <p v-html="hotel.direccion"></p>
            <p><i class="fas fa-phone" /> {{ hotel.telefono }}</p>
            <a
              :href="hotel.ubicacion"
              class="modern-button"
              target="_blank"
              rel="noopener noreferrer"
              :ref="el => setRefs(el, index, 'boton')"
            >
              Location <i class="fas fa-map-marker-alt" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { ref, onMounted, nextTick } from 'vue';
import { gsap } from 'gsap';

import hotel1Img from '@/assets/hotel1.webp';
import hotel2Img from '@/assets/hotel2.webp';

import hotel3Img from '@/assets/hotel3.webp';
import hotel4Img from '@/assets/hotel4.webp';
export default {
  name: 'HospedajeVue',
  setup() {
    const containerRef = ref(null);
    const hotelCards = ref([]);
    const refsMap = ref([]); // refsMap[index] = { titulo, descripcion, imagen, info, boton }
    const currentIndex = ref(0);

   const hotels = [
  {
    titulo: 'Accommodation.',
    descripcion: 'Recommendation.',
    nombre: 'Hilton Garden Inn New Braunfels',
    imagen: hotel1Img,
    direccion: '1501 I 35 N Frontage Rd <br> New Braunfels, TX',
    telefono: '+1 830 62 04 200',
    ubicacion: 'https://maps.app.goo.gl/rCviW8HBQhjDyfb89'
  },
  {
    titulo: 'Accommodation.',
    descripcion: 'Another great option.',
    nombre: 'Hampton Inn & Suites New Braunfels',
    imagen: hotel2Img,
    direccion: '575 Hwy 46 W <br> New Braunfels, TX',
    telefono: '+1 830 60 80 123',
    ubicacion: 'https://maps.app.goo.gl/SxycTgSvGEHFUFNh9'
  },
  {
    titulo: 'Accommodation.',
    descripcion: 'Another great option.',
    nombre: 'Hampton Inn & Suites Selma-San Antonio',
    imagen: hotel3Img,
    direccion: '14655 I-35 N Access Road, Live Oak, San Antonio, United States',
    telefono: '+1 210 590 33 88',
    ubicacion: 'https://maps.app.goo.gl/6otPQVi9MkWUuw838'
  },
  {
    titulo: 'Accommodation.',
    descripcion: 'Another great option.',
    nombre: 'La Quinta Inn by Wyndham San Antonio',
    imagen: hotel4Img,
    direccion: '12822 I-35, San Antonio, United States',
    telefono: '+1 210 657 55 00',
    ubicacion: 'https://maps.app.goo.gl/qwTdxRc1e5L5emTP9'
  }
];


    const setHotelCard = (el, index) => {
      if (el) hotelCards.value[index] = el;
    };

    const setRefs = (el, index, key) => {
      if (!refsMap.value[index]) refsMap.value[index] = {};
      refsMap.value[index][key] = el;
    };

    const animateElements = (elements) => {
      if (!elements) return;

      gsap.fromTo(elements.titulo, { x: -50, opacity: 0 }, { x: 0, opacity: 1, duration: 0.6 });
      gsap.fromTo(elements.descripcion, { opacity: 0, scale: 0.9 }, { opacity: 1, scale: 1, duration: 0.6, delay: 0.2 });
      gsap.fromTo(elements.imagen, { y: 40, opacity: 0 }, { y: 0, opacity: 1, duration: 0.6, delay: 0.4 });
      gsap.fromTo(elements.info, { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: 0.6, delay: 0.6 });
      gsap.fromTo(elements.boton, { scale: 0.8, opacity: 0 }, { scale: 1, opacity: 1, duration: 0.6, delay: 0.8 });
    };

    const prevSlide = () => {
      if (currentIndex.value > 0) {
        currentIndex.value--;
        nextTick(() => animateElements(refsMap.value[currentIndex.value]));
      }
    };

    const nextSlide = () => {
      if (currentIndex.value < hotels.length - 1) {
        currentIndex.value++;
        nextTick(() => animateElements(refsMap.value[currentIndex.value]));
      }
    };

    onMounted(() => {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = hotelCards.value.findIndex(el => el === entry.target);
            if (index !== -1) {
              animateElements(refsMap.value[index]);
              observer.unobserve(entry.target);
            }
          }
        });
      }, { threshold: 0.3 });

      hotelCards.value.forEach(card => {
        if (card) observer.observe(card);
      });
    });

    return {
      containerRef,
      hotelCards,
      hotels,
      currentIndex,
      prevSlide,
      nextSlide,
      setHotelCard,
      setRefs
    };
  }
};
</script>

<style scoped>
.timeline-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 95vh;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.carousel-wrapper {
  position: relative;
  width: 80%;
  overflow: hidden;
}

.carousel {
  display: flex;
  transition: transform 0.6s ease;
}

.hotel-card {
  width: 100%;
  max-width: 500px;
  flex-shrink: 0;
  text-align: center;
  padding: 80px 20px;
  margin: 0 auto;
  border-radius: 0 80px 0 80px;
  background-color: #374336;
  transition: transform 0.3s ease;
}

.hotel-card:hover {
  transform: scale(1.05);
}

.hotel-image {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 20px;
}

.hotel-info {
  font-family: 'Josefin Sans', sans-serif;
  color: rgba(238, 243, 236, 0.9);
}

.hotel-info h3 {
  font-size: 18px;
  color: #e6dede;
}

.hotel-card p {
  font-size: 16px;
  color: #e8e3e3;
}

.recomendacion-hospedaje {
  font-family: 'verde';
  font-size: 34px !important;
  margin-bottom: 12px;
  color: #ebf0e9d7 !important;
}

.modern-button {
  display: inline-block;
  text-decoration: none;
  background: #ffffff;
  color: #333;
  padding: 8px 18px;
  font-family: 'padres';
  font-weight: bold;
  border: none;
  border-radius: 25px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s ease, background 0.5s ease;
  margin-bottom: 15px;
}

.carousel-button {
  position: absolute;
  top: 50%;
  background: #f1efef;
  color: #333;
  width: 44px;
  height: 44px;
  font-size: 28px;
  font-family: 'Arial';
  font-weight: bold;
  z-index: 10;
  cursor: pointer;
  transform: translateY(-50%);
  transition: transform 0.3s ease, opacity 0.3s ease;
  border: none;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.carousel-button.left {
  left: 10px;
  animation: moveLeft 1s infinite ease-in-out;
}

.carousel-button.right {
  right: 10px;
  animation: moveRight 1s infinite ease-in-out;
}

.carousel-button:hover {
  transform: scale(1.3) translateY(-50%);
  opacity: 1;
}

@keyframes moveLeft {
  0%, 100% { transform: translateX(0); opacity: 1; }
  50% { transform: translateX(-10px); opacity: 0.6; }
}

@keyframes moveRight {
  0%, 100% { transform: translateX(0); opacity: 1; }
  50% { transform: translateX(10px); opacity: 0.6; }
}
</style>
